module.exports = __webpack_public_path__ + "i18n/ko_e40151ffa70db8494a3576dbd693d196.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/ko.json
// module id = a8i3
// module chunks = 153